import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../style/contact.css";

const Contactus = ({ setLocation }) => {
  const address = useLocation();

  useEffect(() => {
    setLocation(address);
  }, []);
  return (
    <main>
      <div className="custom-con1-contact position-relative">
        <div className="custom-content-section1-contact position-absolute top-50 start-50 d-flex justify-content-center align-items-center flex-column">
          <p className="custom-header-section1-contact">Contact Us</p>
          <div
            className="row align-items-center m-0 p-0"
            style={{ width: "100%" }}
          >
            <div className="custom-col-size-contact col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 d-flex justify align-items-center flex-column position-relative">
              <i className="custom-icon-contact bi bi-whatsapp"></i>
              <p className="custom-text2-contact text-center">
                +62 898 400 1333{" "}
              </p>
              <button
                className="custom-btn-column-contact position-absolute bottom-0 start-50 translate-middle-x"
                onClick={() =>
                  window.open("https://wa.me/628984001333", "_blank")
                }
              >
                Chat Us
              </button>
            </div>
            <div className="custom-col-size-contact col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 d-flex align-items-center flex-column position-relative">
              <i className="custom-icon-contact bi bi-geo-alt-fill"></i>
              <p className="custom-text2-contact text-center">
                The House Convention Hall Paskal Hyper Square, Bandung City,
                West Java 40172{" "}
              </p>
              <button
                className="custom-btn-column-contact position-absolute bottom-0 start-50 translate-middle-x"
                onClick={() =>
                  window.open(
                    "https://maps.app.goo.gl/6xUztBmMAjJkX1jg7",
                    "_blank",
                  )
                }
              >
                See Location
              </button>
            </div>
            <div className="custom-col-size-contact col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 d-flex align-items-center flex-column position-relative">
              <i className=" custom-icon-contact bi bi-instagram"></i>
              <p className="custom-text2-contact text-center">
                cuttingedge.academy{" "}
              </p>
              <button
                className="custom-btn-column-contact position-absolute bottom-0 start-50 translate-middle-x"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/cuttingedge.academy/",
                    "_blank",
                  )
                }
              >
                Follow Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contactus;
